import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Vashitopunecabs() {



  const cardData = {


  keyword: "Vashi to Pune Cabs",

  headingDescription: "Trustline Cab provides reliable Vashi to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family vacations, industrial visits, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure timely pickups, smooth travel via the Mumbai-Pune Expressway, and a hassle-free journey from Vashi to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, professional drivers, well-maintained vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Vashi to Pune taxi services.",

  topPlaces: [
       {
      title: "Aga Khan Palace",
      description: "Aga Khan Palace is one of Pune's most iconic heritage landmarks, admired for its grand architecture, beautifully maintained gardens, and significant role in India's freedom movement. It is a must-visit attraction for tourists."
    },
     {
      title: "Kharadi",
      description: "Kharadi is one of Pune's premier IT and corporate destinations, home to EON IT Park, multinational companies, business centers, premium hotels, and modern commercial developments. It is a preferred location for professionals and corporate travelers."
    },
    {
      title: "Aundh",
      description: "Aundh is a premium residential and commercial locality known for corporate offices, educational institutions, hospitals, shopping destinations, cafés, and excellent connectivity to Pune's major business hubs."
    },
    {
      title: "Chinchwad",
      description: "Chinchwad is an important commercial and industrial area within Pimpri Chinchwad, featuring automobile industries, engineering companies, business establishments, shopping complexes, and excellent road connectivity."
    },
    {
      title: "Ranjangaon MIDC",
      description: "Ranjangaon MIDC is one of Maharashtra's leading industrial hubs, housing engineering companies, automobile manufacturers, pharmaceutical industries, logistics parks, and large manufacturing facilities."
    },
    {
      title: "Balewadi High Street",
      description: "Balewadi High Street is a vibrant commercial and lifestyle destination offering premium restaurants, cafés, offices, retail outlets, entertainment venues, and modern business infrastructure."
    },
    {
      title: "Yerwada",
      description: "Yerwada is a prominent commercial locality featuring business offices, hotels, hospitals, educational institutions, and excellent connectivity to Pune Airport and central Pune. It is a preferred destination for corporate travelers."
    },
    {
      title: "Parvati Hill",
      description: "Parvati Hill is a historic hilltop destination offering ancient temples, panoramic views of Pune city, and peaceful surroundings. It is a favorite spot for sightseeing, photography, and spiritual visits."
    },
    {
      title: "Mulshi Dam",
      description: "Mulshi Dam is a scenic getaway near Pune, surrounded by lush green hills, tranquil backwaters, waterfalls, and breathtaking landscapes. It is a popular weekend destination for families and nature lovers."
    },
    {
      title: "Tikona Fort",
      description: "Tikona Fort is a historic hill fort overlooking Pawna Lake, famous for its trekking trails, panoramic valley views, and rich Maratha history. It is a favorite destination for trekkers, photographers, and adventure enthusiasts."
    }
  ],






"services": [
  {
    "name": "Vashi to Pune Cab",
    "description": "Book Vashi to Pune Cab with clean AC Sedan, Ertiga, Innova, Innova Crysta, and SUV vehicles for safe and comfortable intercity travel. Enjoy fixed fares, professional chauffeurs, doorstep pickup, online booking, luggage assistance, one way and round trip options, corporate travel, family vacations, airport transfers, and reliable 24x7 customer support."
  },
  {
    "name": "Vashi to Pune Taxi Fare",
    "description": "Check Vashi to Pune Taxi Fare with transparent pricing, affordable packages, multiple vehicle options, fixed rates, and no hidden charges for comfortable outstation travel."
  },
  {
    "name": "Vashi to Pune Taxi Service",
    "description": "Choose Vashi to Pune Taxi Service for reliable outstation travel with experienced drivers, sanitized AC vehicles, flexible pickup timings, airport transfers, and smooth highway journeys."
  },
  {
    "name": "Vashi to Pune One Day Cab",
    "description": "Book Vashi to Pune One Day Cab for same-day business trips, meetings, family travel, and comfortable return journeys with professional chauffeurs and fixed pricing."
  },
  {
    "name": "Vashi to Pune Round Trip Cab",
    "description": "Reserve Vashi to Pune Round Trip Cab with flexible return schedules, premium vehicles, affordable fares, and dependable chauffeur-driven transportation."
  },
  {
    "name": "Vashi to Pune Ertiga Cab",
    "description": "Hire Vashi to Pune Ertiga Cab for spacious six-seater travel, family vacations, airport transfers, business trips, and comfortable long-distance journeys."
  },
  {
    "name": "Vashi to Pimpri Chinchwad Cab",
    "description": "Book Vashi to Pimpri Chinchwad Cab with fixed fares, AC vehicles, experienced drivers, and reliable outstation transportation."
  },
  {
    "name": "Vashi to Wanowrie Cab",
    "description": "Reserve Vashi to Wanowrie Cab with professional chauffeurs, affordable pricing, clean vehicles, and comfortable intercity travel."
  },
  {
    "name": "Vashi to Pune Sedan Cab",
    "description": "Travel with Vashi to Pune Sedan Cab for economical and comfortable outstation transportation featuring clean AC cars, professional drivers, and fixed fares."
  },
  {
    "name": "Vashi to Pune Innova Crysta",
    "description": "Book Vashi to Pune Innova Crysta for luxury family travel, corporate transfers, airport pickup, spacious seating, premium comfort, and ample luggage capacity."
  },
  {
    "name": "Vashi to Aundh Cab",
    "description": "Choose Vashi to Aundh Cab for safe and convenient travel with experienced chauffeurs, transparent pricing, and comfortable AC vehicles."
  },
  {
    "name": "Cab Service in Vashi",
    "description": "Hire Cab Service in Vashi for local rides, airport transfers, Pune trips, outstation travel, business meetings, and family journeys with professional drivers."
  },
  {
    "name": "Vashi to Pune Station Cabs Service",
    "description": "Book Vashi to Pune Station Cabs Service with punctual railway station pickup and drop, affordable fares, experienced chauffeurs, and comfortable vehicles."
  },
  {
    "name": "Taxi Service in Navi Mumbai",
    "description": "Choose Taxi Service in Navi Mumbai for local travel, airport transfers, outstation trips, corporate travel, and comfortable chauffeur-driven transportation."
  },
  {
    "name": "Outstation Cab Booking in Vashi",
    "description": "Complete Outstation Cab Booking in Vashi with instant confirmation, secure reservations, fixed pricing, multiple vehicle options, and reliable customer support."
  },
  {
    "name": "Vashi to Pune Cabs",
    "description": "Reserve Vashi to Pune Cabs with Sedan, Ertiga, Innova, Innova Crysta, SUV, and luxury vehicles for comfortable one way and round trip travel."
  },
  {
    "name": "Vashi to Pune Cab Service",
    "description": "Our Vashi to Pune Cab Service offers fixed fares, premium AC vehicles, experienced chauffeurs, online booking, and dependable intercity transportation."
  },
  {
    "name": "Vashi to Pune Taxi Service",
    "description": "Travel with Vashi to Pune Taxi Service featuring affordable fares, professional drivers, clean AC vehicles, luggage assistance, and smooth highway journeys."
  },
  {
    "name": "Vashi to Pune One Way Cab",
    "description": "Book Vashi to Pune One Way Cab with transparent pricing, instant booking, doorstep pickup, experienced chauffeurs, and comfortable long-distance travel."
  },
  {
    "name": "Vashi to Pune Taxi Fare",
    "description": "Compare Vashi to Pune Taxi Fare with fixed packages, affordable pricing, multiple cab choices, and no hidden costs."
  },
  {
    "name": "Vashi to Pune Cab Booking",
    "description": "Complete Vashi to Pune Cab Booking online with secure payment, instant confirmation, professional drivers, and flexible pickup timings."
  },
  {
    "name": "Cab from Vashi to Pune",
    "description": "Book Cab from Vashi to Pune for business travel, family vacations, airport transfers, and comfortable chauffeur-driven intercity journeys."
  },
  {
    "name": "Vashi to Pune Car Rental",
    "description": "Hire Vashi to Pune Car Rental with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for one way, round trip, and corporate travel."
  },
  {
    "name": "Vashi to Pune Taxi Booking Online",
    "description": "Reserve Vashi to Pune Taxi Booking Online with quick confirmation, transparent fares, reliable chauffeurs, and 24x7 booking availability."
  },
  {
    "name": "Cheap Cab Vashi to Pune",
    "description": "Book Cheap Cab Vashi to Pune with economical fares, clean AC vehicles, experienced drivers, and dependable outstation transportation."
  },
  {
    "name": "Vashi to Pune Outstation Cab",
    "description": "Choose Vashi to Pune Outstation Cab for safe and comfortable long-distance travel with fixed fares, premium vehicles, and experienced chauffeurs."
  },
  {
    "name": "Vashi to Pune AC Taxi Service",
    "description": "Travel comfortably with Vashi to Pune AC Taxi Service featuring air-conditioned vehicles, affordable pricing, professional drivers, and smooth highway rides."
  },
  {
    "name": "Vashi to Pune Innova Cab",
    "description": "Reserve Vashi to Pune Innova Cab for spacious family travel, airport transfers, business meetings, group tours, and premium comfort."
  },
  {
    "name": "Vashi to Pune Cab Price",
    "description": "Check Vashi to Pune Cab Price with transparent fare estimates, fixed pricing, multiple vehicle options, and affordable packages for every travel requirement."
  }
],

"tableData": [
  ["Vashi to Pune Cab", "Vashi to Pune Taxi Fare"],
  ["Vashi to Pune Taxi Service", "Vashi to Pune One Day Cab"],
  ["Vashi to Pune Round Trip Cab", "Vashi to Pune Ertiga Cab"],
  ["Vashi to Pimpri Chinchwad Cab", "Vashi to Wanowrie Cab"],
  ["Vashi to Pune Sedan Cab", "Vashi to Pune Innova Crysta"],
  ["Vashi to Aundh Cab", "Cab Service in Vashi"],
  ["Vashi to Pune Station Cabs Service", "Taxi Service in Navi Mumbai"],
  ["Outstation Cab Booking in Vashi", "Vashi to Pune Cabs"],
  ["Vashi to Pune Cab Service", "Vashi to Pune Taxi Service"],
  ["Vashi to Pune One Way Cab", "Vashi to Pune Taxi Fare"],
  ["Vashi to Pune Cab Booking", "Cab from Vashi to Pune"],
  ["Vashi to Pune Car Rental", "Vashi to Pune Taxi Booking Online"],
  ["Cheap Cab Vashi to Pune", "Vashi to Pune Outstation Cab"],
  ["Vashi to Pune AC Taxi Service", "Vashi to Pune Innova Cab"],
  ["Vashi to Pune Cab Price", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Vashi to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab provides dependable Vashi to Pune cab services with comfortable vehicles, professional chauffeurs, and convenient intercity transportation for every journey."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Vashi",
    WhyChoosedescription: "Book hassle-free pickup from Vashi Railway Station, Sector 1 to Sector 30, offices, hotels, malls, and residential societies with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Comfortable & Safe Highway Travel",
    WhyChoosedescription: "Travel with experienced drivers who ensure a smooth, safe, and punctual journey via the Mumbai–Pune Expressway using the best available routes."
  },
  {
    WhyChooseheading: "Wide Choice of Well-Maintained Vehicles",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to suit your travel requirements, luggage, and group size."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Costs",
    WhyChoosedescription: "Get a detailed fare quotation before confirming your booking with competitive rates and complete pricing transparency."
  },
  {
    WhyChooseheading: "One Way, Round Trip & Flexible Travel",
    WhyChoosedescription: "Book one-way cabs, return journeys, airport transfers, or customized travel packages according to your preferred schedule."
  },
  {
    WhyChooseheading: "Ideal for Corporate, Family & Airport Travel",
    WhyChoosedescription: "Our Vashi to Pune cab service is suitable for business executives, family vacations, student travel, airport transfers, and weekend getaways."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Assistance",
    WhyChoosedescription: "Reserve your Vashi to Pune cab anytime with instant confirmation and dedicated customer support for a stress-free travel experience."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Vashi to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Vashi to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Vashi to Pune?",
    answer: "Yes, one-way cab services are available with doorstep pickup from Vashi and direct drop anywhere in Pune."
  },
  {
    question: "Do you provide pickup from Vashi Railway Station and all sectors?",
    answer: "Yes, we provide pickup from Vashi Railway Station, all sectors of Vashi, offices, hotels, residential societies, and nearby Navi Mumbai locations."
  },
  {
    question: "Which vehicles are available for Vashi to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable intercity travel."
  },
  {
    question: "Is Vashi to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7, allowing you to travel according to your preferred timing."
  },
  {
    question: "Can I reserve a return cab from Pune to Vashi?",
    answer: "Yes, round-trip cab services are available for passengers planning return travel between Pune and Vashi."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in the confirmed booking quotation."
  },
  {
    question: "Should I reserve my Vashi to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and your preferred pickup schedule."
  },
  {
    question: "Do you provide Vashi to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are ideal for business meetings, employee transportation, executive travel, and client visits."
  },
  {
    question: "How can I book Vashi to Pune Cabs with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harsh Vora",
    feedback: "The Vashi to Pune cab service was excellent from start to finish. The driver arrived before the scheduled time, the vehicle was clean, and the journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anuja Patankar",
    feedback: "Trustline Travels provided a professional travel experience with quick booking, courteous service, and a well-maintained cab. Our trip from Vashi to Pune was safe, relaxing, and perfectly organized.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Vashi to Pune Cabs",
  "image": "https://www.trustlinetravels.com/assets/images/vashi-to-pune-cabs.webp",
  "description":
    "Book Vashi to Pune Cabs with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Vashi to Pune, Pimpri Chinchwad, Wanowrie, Aundh, Pune Railway Station, and all Pune locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/vashi-to-pune-cabs"
  }
};






  return (
    <div>

<Helmet>
  <title>Vashi to Pune Cabs | One Way Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Vashi to Pune Cabs with Trustline Travels for reliable one-way and round-trip taxi services. Travel from Vashi to Pune, Pimpri Chinchwad, Wanowrie, Aundh, Pune Railway Station, and nearby destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Vashi to Pune Cab, vashi to pune taxi fare, vashi to pune taxi service, vashi to pune one day cab, vashi to pune round trip cab, vashi to pune ertiga cab, vashi to pimpri chinchwad cab, vashi to wanowrie cab, vashi to pune sedan cab, vashi to pune innova crysta, vashi to aundh cab, Cab Service in Vashi, vashi to pune station cabs service, Cab Service Vashi to Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Vashitopunecabs;